module.exports = __webpack_public_path__ + "img/1.8e5a2aef.jpg";